import { TemplateAssignedOffer } from '@recruitee/http/types';

export enum EntityStoreKey {
  EmailTemplatesGeneral = 'emailTemplatesGeneral',
  EmailTemplatesAutoReplyCollection = 'emailTemplatesAutoReplyCollection',
  EmailTemplatesAutoReplyItem = 'emailTemplatesAutoReplyItem',
  EmailTemplatesEventInvitation = 'emailTemplatesEventInvitation',
  EmailTemplatesAssignedOffers = 'emailTemplatesAssignedOffers',
}

export type EventInvitationCollectionPayload = { includeLastUsed: 'candidate' | 'interviewer' };

export type EmailTemplatesAssignedOffersList = {
  assignedOffers: TemplateAssignedOffer[];
  meta: { limit: number; page: number; totalCount: number };
};
